import {
    setAddress, 
    getAddress, 
    setCustomerAddressList,
    getCustomerAddressList, 
    setDefaultAddress,
    getDefaultAddress,
} from "#/storage/address";

//
import { Toast } from "vant-ui";
import axios from "#/net/axios";
import Vue from "vue";

//
import address_pb from '../../protocols_js/address_pb';

//
import { getShopStaticResouceUrl, } from "#/utils/common.js"
import areaList from "./areaList.json";

//
let fetchCustomerAddressRequestList = [];
let fetchCustomerAddressRequestProcessing = false;

/**
 * vuex
 */
const state = {
    address: getAddress(),
    customerAddress: getCustomerAddressList() || {
        addressList: [],
        addressTopOne: null,
    },
    areaList: areaList,
    defaultAddress: getDefaultAddress(),
}

const getters = {

}

const mutations = {
    setAddress(state, data) {
        //
        state.address = data;

        //
        setAddress(data);
    },

    setCustomerAddress(state, data) {
        //
        state.customerAddress = data;

        //
        setCustomerAddressList(data);
    },

    setDefaultAddress(state, data) {
        state.defaultAddress = data;

        //
        setDefaultAddress(data);

        //
        Vue.set(state.defaultAddress, `time_${Date.now()}`, "CurrentDate");
    },

    setAreaList(state, data) {
        state.areaList = data;
    },
}

const actions = {
    fetchUserAddress({commit}, callback) {
        try
        {
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.listenerAdded) {
                window.gtznZiubaoNavigator.getCurrentPosition(position => {
                    //
                    console.log(`ios get position info, lng: ${position.coords.longitude}, lat: ${position.coords.latitude}`);

                    AMap.plugin('AMap.Geocoder', function() {
                        let geocoder = new AMap.Geocoder({
                            radius: 1000 // 范围，默认：500
                        });
    
                        geocoder.getAddress([position.coords.longitude + '', position.coords.latitude + ''], function(status, result) {
                            if (status === 'complete' && result.regeocode) {
                                //
                                commit('setAddress', {
                                    position: {
                                        lng: position.coords.longitude,
                                        lat: position.coords.latitude,
                                    },

                                    addressComponent: result.regeocode.addressComponent,
                                    formattedAddress: result.regeocode.formattedAddress,
                                })
    
                                //
                                if (callback) {
                                    callback(true);
                                }
    
                                //
                                return;
                            }
                            else if(status == 'error')
                            {
                                //
                                console.log(`定位获取失败, 请刷新页面重试, ${result}`);
                            }
                            else
                            {
                                console.log('定位获取失败, 无法定位到用户当前位置');
                            }
                        });
                    })
                });
            }
            else {
                // fetch position
                AMap.plugin('AMap.Geolocation', () => {
                    var geolocation = new AMap.Geolocation({
                        // 是否使用高精度定位，默认：true
                        enableHighAccuracy: true,
                        // 设置定位超时时间，默认：无穷大
                        timeout: 10000,
                        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                        buttonOffset: new AMap.Pixel(10, 20),
                        //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                        zoomToAccuracy: true,
                        //  定位按钮的排放位置,  RB表示右下
                        buttonPosition: 'RB'
                    })

                    geolocation.getCurrentPosition()
                    AMap.event.addListener(geolocation, 'complete', data => {
                        //
                        if (data.addressComponent) {
                            commit('setAddress', data)

                            //
                            if (callback) {
                                callback(true);
                            }

                            //
                            console.log(`userAddress, ${JSON.stringify(data)}`);
                        }
                        else
                        {
                            let geocoder = new AMap.Geocoder({
                                radius: 1000 // 范围，默认：500
                            });

                            geocoder.getAddress([data.position.lng + '', data.position.lat + ''], function (status, result) {
                                if (status === 'complete' && result.regeocode) {
                                    const addressAfterProcess = {
                                        position: {
                                            lng: data.position.lng,
                                            lat: data.position.lat,
                                        },

                                        addressComponent: result.regeocode.addressComponent,
                                        formattedAddress: result.regeocode.formattedAddress,
                                    }

                                    //
                                    commit('setAddress', addressAfterProcess)
                                        
                                    //
                                    if (callback) {
                                        callback(true);
                                    }

                                    //
                                    console.log(`userAddress, ${JSON.stringify(addressAfterProcess)}`);

                                    //
                                    return;
                                }
                                else if (status == 'error') {
                                    //
                                    console.log(`定位获取失败, 请刷新页面重试, ${result}`);
                                }
                                else {
                                    console.log('定位获取失败, 无法定位到用户当前位置');
                                }
                            });
                        }
                    })
                    AMap.event.addListener(geolocation, 'error', data => {
                        //
                        if (callback) {
                            callback(false);
                        }

                        //
                        console.log("无法获得定位信息, 请确认是否打开定位功能, 然后刷新页面");
                    });
                });
            }
        } catch(e) {
            //
            console.log("无法获得定位信息, 请确认是否打开定位功能, 然后刷新页面");

            //
            if (callback) {
                callback(false);
            }
        }
        
    },

    fetchCustomerAddress({ dispatch, commit, state }, shopId)
    {
        //
        if (shopId != 'command_omit_push_ajax_request')
        {
            fetchCustomerAddressRequestList.push(shopId);
        }
        
        //
        if (fetchCustomerAddressRequestProcessing)
        {
            return;
        }

        //
        fetchCustomerAddressRequestProcessing = true;

        /**
         * 
         */
        setTimeout(() => {
            //
            let fetchCustomerAddressRequestListLength = fetchCustomerAddressRequestList.length;

            //
            axios.shop.get("/newShop/showAddressList.do", {
                shopId: fetchCustomerAddressRequestList[fetchCustomerAddressRequestListLength - 1],
            }).then(({ statusCode, data, msg }) => {
                if (statusCode != '200' && statusCode != '401' && statusCode != '900') {
                    // return Toast(`获取收货地址列表失败, ${msg}`);
                }
                else if (statusCode == '200') {
                    /**
                     * 
                     */
                    let addressJsonTarget = {
                        addressList: [],
                        addressTopOne: null,
                    }

                    //
                    const addressList = address_pb.AddressList.deserializeBinary(data)
                    
                    //
                    const addressInfoList = addressList.getAddressInfoList();

                    //
                    if (addressInfoList && addressInfoList.length > 0) {
                        for (let addressInfo of addressInfoList) {
                            //
                            const addressInfoJson = {
                                aId: addressInfo.getId(),
                                aAddressCity: addressInfo.getAddressCity(),
                                chooseAddress: addressInfo.getAddressChoose(),
                                aAddressDetail: addressInfo.getAddressDetail(),
                                aName: addressInfo.getName(),
                                aMobile: addressInfo.getMobile(),
                                transportationMode: addressInfo.getTransportationMode(),
                                transportationDescriptionList: addressInfo.getTransportationDescriptionList(),
                                addressType: addressInfo.getAddressType(),
                                lat: addressInfo.getAddressLatitute(),
                                lng: addressInfo.getAddressLongigute(),
                            }
                            
                            //
                            addressJsonTarget.addressList.push(addressInfoJson);

                            if (addressInfo.getAddressType() == address_pb.ADDRESS_TYPE.ADDRESS_TYPE_DEFAULT)
                            {
                                addressJsonTarget.addressTopOne = addressInfoJson;
                            }
                        }
                    }

                    if (process.env.NODE_ENV == 'development')
                    {
                        // console.log(JSON.stringify(addressJsonTarget))
                    }
                    
                    /**
                     * 
                     */
                    commit('setCustomerAddress', addressJsonTarget);

                    //
                    if (state.defaultAddress == null && addressJsonTarget.addressTopOne) {
                        commit("setDefaultAddress", addressJsonTarget.addressTopOne)
                    }
                    else if (state.defaultAddress != null && state.defaultAddress.aId != null)
                    {
                        // update default address
                        for (let address of addressJsonTarget.addressList)
                        {
                            if (address.aId == state.defaultAddress.aId)
                            {
                                commit("setDefaultAddress", address);

                                //
                                break;
                            }
                        }
                    }
                }
            }).catch(e => {
                // Toast(`获取收货地址失败, ${e.toString()}`);
            }).finally(() => {
                //    
                fetchCustomerAddressRequestList.splice(0, fetchCustomerAddressRequestListLength)
 
                //
                fetchCustomerAddressRequestProcessing = false;

                // keep going
                if (fetchCustomerAddressRequestList.length > 0)
                {
                    dispatch("fetchCustomerAddress", "command_omit_push_ajax_request")
                }
            });
        }, 100);
    },

    fetchAreaList({
        commit,
    }) {
        axios.static_resource.get('data/area.json', null, {
                'Cache-Control': 'no-cache'
            })
            .then(data => {
                // handle success
                commit('setAreaList', data);
            }).catch((error) => {
                // handle error
                Toast(`获取区域信息出错, ${error.toString()}`)
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
